import TablePage from '@/found/components/table_page';
import * as utils from '@/found/utils/index';
import Form from './form';
import DetailForm from './form/detail.vue';
import ChangeForm from './form/form-change';
import AdjustmentForm from './form/form-edit-adjust';
import ImportForm from './form/import_form.vue';

export default {
  name: 'terminal_fee',
  extends: TablePage,
  data() {
    return {};
  },
  components: {
    Form,
    DetailForm,
    ChangeForm,
    AdjustmentForm,
    ImportForm,
  },
  created() {
    this.getConfigList('tpm_fee_budget');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      } else if (val.code === 'detail') {
        this.formName = 'DetailForm';
        this.modalConfig = {
          title: '明细',
          width: '80%',
        };

        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
          feeBudgetCode: row.feeBudgetCode,
        };

        this.openDrawer();
      } else if (val.code === 'change') {
        this.formName = 'ChangeForm';
        this.modalConfig = {
          title: '变更',
          width: '60%',
        };

        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };

        this.openDrawer();
      } else if (val.code === 'adjustment') {
        this.formName = 'AdjustmentForm';
        this.modalConfig = {
          title: '调整',
          width: '60%',
        };

        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };

        this.openDrawer();
      } else if (val.code === 'tpm_fee_budget_change_import') {
        this.formName = 'ImportForm';
        this.modalConfig = {
          title: '导入文件',
          width: '800px',
          height: '60vh',
        };
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
          exportMessage: '',
          sid: utils.getUuid(32, 16),
        };
        this.modalConfig = {
          ...this.modalConfig,
        };
        this.openModal();
      } else if (val.code === 'tpm_fee_budget_change_export') {
        const a = document.createElement('a');
        a.href = '/tpm/v1/tpmFeeBudgetController/improt/exportTemplate';
        document.body.appendChild(a);
        a.click(); // 下载
        URL.revokeObjectURL(a.href); // 释放URL 对象
        document.body.removeChild(a); // 删除 a 标签
      }
    },
  },
};
